module.exports = __webpack_public_path__ + "img/file-icon-doc.a5e8e6db.svg";